/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { Link } from 'react-router-dom'
// import images from 'common_constants/images'
import styles from './View.Style'
import Button from 'components_newui/button/View'
// import Idea_Panel from '../../components_newui/idea_panel/View'
// import Challenge_Card from '../../components_newui/challenge_card/View'
import ChallengeCarousel from '../../components_newui/challenge_carousel/View'
import RecommendedIdeas from '../../components_newui/recommended_ideas/View'
// import no_draft_ideas_img from '../../img/no_draft_idea.png'
// import heroImg from 'img/hero_image.png'
import heroImg from 'img/innovate/banner2.png'
import chevron from 'img/chevron-up-purple.png'
// import { CHALLENGES_PAGE } from '../../common_constants/Pages'
import Contributor from './components/contributor/View'
import contributorBg from 'img/champion_bg.png'
import contributorTypes from './contributor_type'
import Loader from 'support/loader/nxt_loader'
import { Container } from '@material-ui/core'

import myIdeaIcon from 'img/my-idea.png'
import myChallengeTagIcon from 'img/challenge-tag.png'
import ideaInvestIcon from 'img/idea-invest.png'
import myChallengeIcon from 'img/my-challenge.png'
import noIdeasImg from 'img/no_ideas.png';
import HWC from 'img/HWC_Home_page.jpg'
// import { AllIdeasPath } from 'support/navigation/linkRoutePath'
import * as pages from 'common_constants/Pages'
import NavigationService from 'support/navigation/NavigationService'
import FourBoxLoading from 'components_newui/FourBoxLoading'
import IdeaChallengePopup from 'components_newui/IdeachallengePopup/IdeaChallengePopup'
import CommonDialog from 'components_newui/dialogs/CommonDialog';
import TermsCheckbox from './TermAndCondition'
import ParentComponentTnc from './ParentComponentTnc'
import { ShowPopupCountrySelectFirstTime } from './ShowPopupCountrySelectFirstTime '
import { CHALLENGE_LOAD_MORE_SIZE, LOAD_MORE_SIZE, PAGE_SIZE } from 'common_constants/Ideas'




const HeroSectionComponents = (props) => {
    const { classes, isAdmin, submitYourIdea, setShowIdeaChallengeModal, showIdeaChallengeModal, isHackathonEnable,
        challengesList,
        getActiveChallenges,
        getInnovateChallengeAllListFn,
        getInnovateChallengeFilterListFn,
        filterListInnovateChallenge,
        filterListInnovateChallengeLoading,
        listInnovateChallenge,

        listInnovateChallengeLoading, filterListInnovateChallengeTotal } = props
    const [offset, setOffset] = useState(0);
    const [challengeFilterAllData, setChallengeFilterAllData] = useState([]);
    const conditionBasedChallengeList = isHackathonEnable ? filterListInnovateChallenge?.data : challengesList



    const handleOpenIdeaModal = () => {
        setShowIdeaChallengeModal(true);
        setChallengeFilterAllData([])
        setOffset(0);
        if (isHackathonEnable) {
            getInnovateChallengeFilterListFn("ACTIVE", 0, CHALLENGE_LOAD_MORE_SIZE, isHackathonEnable);

        } else {
            getActiveChallenges('ACTIVE', 0, 11, isHackathonEnable)
        }
    };

    useEffect(() => {
        setChallengeFilterAllData((prev) => [...prev, ...filterListInnovateChallenge])
    }, [filterListInnovateChallenge])

    const handleCloseIdeaModal = () => setShowIdeaChallengeModal(false);
    const handleOnLoadMore = () => {
        // console.log("popup load...")
        const currentOffset = offset || 0;
        const newLimit = currentOffset ? LOAD_MORE_SIZE : PAGE_SIZE
        const newOffset = newLimit + currentOffset
        // Call API with current offset and limit
        getInnovateChallengeFilterListFn(
            'ACTIVE',
            newOffset,
            LOAD_MORE_SIZE,
            isHackathonEnable,
        );

        // Update offset for next call
        setOffset(newOffset);
    };



    return (
        <div className={classes.heroContainer}>
            {/* <img className={classes.heroImg} src={heroImg} alt='img' /> */}
            <img className={classes.heroImg} src={HWC} alt='img' />
           <div className={classes.hero__heading}> 
           <h2 className={classes.exploresubheading}>{`We're calling on innovators, dreamers, and game-changers to bring their best ideas to the pitch. The Hack World Cup is your chance to showcase bold solutions that can shape the future of tech, people and progress.`}</h2> 
           <button type='button'
                    // onClick={submitYourIdea} 
                    onClick={handleOpenIdeaModal}
                    className={classes.postIdea}>Submit an Idea</button>
           </div>
            {/* <div className={classes.heroContent}>
                <div className={classes.exploreheading}>Shape the Future of Vodacom</div>
                <div className={classes.exploresubheading} >Have a great idea? Let the Innovate community know about it</div>
                <button type='button'
                    // onClick={submitYourIdea} 
                    onClick={handleOpenIdeaModal}
                    className={classes.postIdea}>Submit an Idea</button>
            </div> */}
            {showIdeaChallengeModal ?
                <IdeaChallengePopup
                    filterListInnovateChallengeTotal={filterListInnovateChallengeTotal}
                    listInnovateChallengeLoading={filterListInnovateChallengeLoading}
                    enableIsHackathon={isHackathonEnable}
                    onClickLoadMore={handleOnLoadMore}
                    onClose={handleCloseIdeaModal}
                    challengesList={challengeFilterAllData}
                    isAdmin={isAdmin}
                /> :
                null
            }
        </div>
    )
}




const LatestIdeaComponents = ({
    ideas,
    classes,
    AllIdeasPath,
    isIdeasLoading,
    ifHackthonTrueGetInnovateIdeaIsLoading,
    ifHackthonTrueGetInnovateIdea,
    isHackathonEnable,
}) => {
    const innovateIdea = ifHackthonTrueGetInnovateIdea?.data || [];

    const isLoading = isIdeasLoading || ifHackthonTrueGetInnovateIdeaIsLoading;

    if (isLoading) {
        return <FourBoxLoading />;
    }

    const recommendedIdeas = isHackathonEnable ? innovateIdea : ideas;
    //   console.log("🚀 ~ LatestIdeaComponents ~ recommendedIdeas:", recommendedIdeas , ideas, innovateIdea)

    return (

        recommendedIdeas?.length === 0 ?
            (
                <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                    <img className={classes.noIdeaImg} src={noIdeasImg} alt="no idea found" />
                    <p className={classes.noIdeas}>
                        No existing <span className={classes.purpleNo}>ideas</span>
                    </p>
                </div>
            )

            :

            <>
                <RecommendedIdeas bg_color="#fbfaff" recommendedIdeas={recommendedIdeas} />

                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '3rem' }}>
                    <Link to={AllIdeasPath} className={classes.standard_button}>
                        View all
                    </Link>
                </div>
            </>
    );
};




const LatestChallengeComponents = (props) => {
    const { challenges, classes, AllChallengesPath, navigateToChallengeDetail, ischallengesLoading } = props
    if (ischallengesLoading) {
        return <FourBoxLoading />
    }
    return (
        challenges && challenges.length > 0 ? <>
            <div className={classes.generic_holder} >
                <div className={classes.title_text}>Challenges</div>
                <div className={classes.subtitle_text} style={{ marginBottom: '32px' }}>
                    Step up to the challenge and impact Vodacom future
                </div>

                <ChallengeCarousel challenges={challenges} navigateToChallengeDetail={navigateToChallengeDetail} />
                <div className={classes.alignbtn}>
                    <Link to={`${AllChallengesPath}`} className={classes.standard_button}>
                        View all
                    </Link>
                    {/* <button type='button' onClick={navigateToChallenges} className={classes.standard_button}>View all</button> */}
                </div>
            </div>  </> : null
    )
}


const GerericIdeaChallegeComponents = (props) => {

    const { classes, isHackathonEnable, listOfInnovateIdea, userIdeas, challenges, submitYourIdea, isAdmin, isOwner, isInnovator, localAdmin, investments, challenge_ideas,
        AllIdeasPath, AllChallengesPath, NewCHALLENGEPath, PROPOSECHALLENGEPath, canProposeChallenge } = props

    return (
        <div className={classes.generic_list}>
            <div className={classes.info_card}>
                <div className={classes.info_card_bulk}>
                    <div style={{ borderRight: '1px solid #CCCCCC' }} className={classes.infoCardSection}>
                        <div className='countHeading'>
                            <div className={classes.exploreIcons}>
                                <img src={myIdeaIcon} className={classes.countIcon} alt='icon' />
                            </div>
                            <h3> My Ideas</h3>
                        </div>
                        <div className={classes.number_info}>{userIdeas.length}</div>
                    </div>
                    <div className={classes.infoCardSection}>
                        <div className='countHeading'>
                            <div className={classes.exploreIcons}>
                                <img src={myChallengeIcon} className={classes.countIcon} alt='icon' />
                            </div>
                            <h3> Active Challenges </h3>
                        </div>
                        <div className={classes.number_info}>{challenges.length}</div>
                    </div>
                </div>
                <div className={classes.info_card_footer}>
                    <div className={classes.info_card_footer_section}>
                        {/* <span onClick={submitYourIdea} style={{ cursor: 'pointer' }} className={classes.info_card_footer_subsection}> */}
                        {/* <Link to={`${}`} className={classes.btnTrasparents}>
                            Post an idea <img src={chevron} className={classes.chevron_right} />
                       </Link> */}
                        {/* <button type='button' onClick={submitYourIdea} className={classes.btnTrasparents} >
                            Post an idea <img src={chevron} className={classes.chevron_right} alt='img' />
                        </button> */}
                        {/* </span> */}
                    </div>
                    <div className={classes.info_card_footer_section}>
                        {/* {
                            Boolean(isAdmin || isInnovator || localAdmin) && (
                                <Link to={`${NewCHALLENGEPath}`} className={classes.btnTrasparents} >
                                    Create challenge <img src={chevron} className={classes.chevron_right} alt='img' />
                                </Link>)
                        }
                        {
                            Boolean(canProposeChallenge) &&
                            <Link onClick={`${PROPOSECHALLENGEPath}`} className={classes.btnTrasparents} >
                                Propose a challenge <img src={chevron} className={classes.chevron_right} alt='icon' />
                            </Link>
                        } */}

                    </div>
                </div>
            </div>
            <div className={classes.info_card}>
                <div className={classes.info_card_bulk}>
                    <div style={{ borderRight: '1px solid #CCCCCC' }} className={classes.infoCardSection}>
                        <div className='countHeading'>
                            <div className={classes.exploreIcons}>
                                <img src={myIdeaIcon} className={classes.countIcon} alt='icon' />
                            </div>
                            {isHackathonEnable ? (<h3> All Ideas </h3>) : (<h3>  Ideas   <p>(I have invested in)</p></h3>)}
                        </div>
                        {isHackathonEnable ?
                            <div className={classes.number_info}>{listOfInnovateIdea?.data?.length || 0}</div> :
                            <div className={classes.number_info}>  {investments?.length} </div>
                        }

                    </div>
                    <div className={classes.infoCardSection}>
                        <div className='countHeading'>
                            <div className={classes.exploreIcons}>
                                <img src={myChallengeTagIcon} className={classes.countIcon} alt='icon' />
                            </div>
                            <h3> Challenges <p>(I have tagged my ideas to)</p></h3>
                        </div>
                        <div className={classes.number_info}>{challenge_ideas?.length}</div>
                    </div>
                </div>
                <div className={classes.info_card_footer}>
                    <div className={classes.info_card_footer_section}>
                        {/* <span onClick={navigateToAllIdeas} style={{ cursor: 'pointer' }} className={classes.info_card_footer_subsection}> */}
                        {isInnovator || isAdmin}
                        <Link to={`${AllIdeasPath}`} className={classes.btnTrasparents} >
                            Explore more ideas <img src={chevron} className={classes.chevron_right} alt='icon' />
                        </Link>
                        {/* </span> */}
                    </div>
                    <div className={classes.info_card_footer_section}>
                        {/* <span onClick={navigateToChallenges} style={{ cursor: 'pointer' }} className={classes.info_card_footer_subsection}> */}
                        <Link to={`${AllChallengesPath}`} className={classes.btnTrasparents} >
                            Explore challenges <img src={chevron} className={classes.chevron_right} alt="icon" />
                        </Link>
                        {/* </span> */}
                    </div>
                </div>
            </div>
        </div>
    )
}


const NewExplore = props => {

    const ROUTES = NavigationService.getRoutes()
    const AllIdeasPath = ROUTES[pages.ALL_IDEAS].path
    const AllChallengesPath = ROUTES[pages.CHALLENGES_PAGE].path
    const NewCHALLENGEPath = ROUTES[pages.NEW_CHALLENGE].path
    const PROPOSECHALLENGEPath = ROUTES[pages.PROPOSE_CHALLENGE].path
    const RANKINGPAGEPath = ROUTES[pages.RANKING_PAGE].path


    const {
        isHackathonEnable,
        challengesList,
        filterListInnovateChallenge,
        filterListInnovateChallengeLoading,
        listInnovateChallenge,
        listInnovateChallengeLoading,
        classes,
        domainLoaded,
        ideas,
        challenges,
        navigateToIdea,
        navigateToProposeChallenge,
        navigateToNewChallenge,
        submitYourIdea,
        footerInvestors,
        footerEntrepreneurs,
        navigateToRanking,
        navigateToAllIdeas,
        navigateToChallenges,
        navigateToChallengeDetail,
        userIdeas,
        investments,
        userEmail,
        isIdeasLoading,
        navigateToInvestments, navigateToMyInvestedIdea,
        isAdmin, isInnovator, isOwner, localAdmin, localInnovator,
        getApiResponseInnovateIdeaIfHackathonTrue,
        ifHackthonTrueGetInnovateIdea,
        ifHackthonTrueGetInnovateIdeaIsLoading,
        updateTermAndConditionAcceptenceFn,
        isTermAcceptedFirstTime,
        isTermAcceptedFirstTimeIsLoading,
        getBenchCountriesListFn,
        getBenchCountriesList,
        getFirstTimeCheckAceptanceCountryFn,
        postAddCountryAcceptenceFn,
        loginUser,
        isCommunityAssigned,
        isCommunityAssignedFirstTime,
        currentDomain,
    } = props
    // const isTermAcceptedFirstTime = false

    const [apiTest, setApiTest] = useState();
    const [showIdeaChallengeModal, setShowIdeaChallengeModal] = useState(false);

    useEffect(() => {
        const {
            getActiveChallenges,
            getIdeas,
            getRankings,
            getMyIdeas,
            getInvestments,
            getFirstTimeCheckAceptanceTncFn,
        } = props

        if (domainLoaded) {
            getActiveChallenges('ACTIVE', 0, 11, false, isHackathonEnable)
            getIdeas(isHackathonEnable)
            getRankings()
            getMyIdeas()
            getInvestments(userEmail)
            getFirstTimeCheckAceptanceTncFn(userEmail)
            getFirstTimeCheckAceptanceCountryFn(userEmail,currentDomain)
            getBenchCountriesListFn()
        }
    }, [domainLoaded, isHackathonEnable])


    useEffect(() => {
        if (isHackathonEnable) {
            getApiResponseInnovateIdeaIfHackathonTrue(0,LOAD_MORE_SIZE,true)
        }
    }, [isHackathonEnable])

    // const isCommunityAssignedFirstTime = false

    const challenge_ideas = userIdeas.filter(idea => idea.challenged === true)
    // console.log("===> before ==isCommunityAssignedFirstTime ===>", isCommunityAssignedFirstTime, !isCommunityAssignedFirstTime)
    const checkisCommunityAssignedFirstTime  = !isCommunityAssignedFirstTime


    return (
        <>

            <main className={classes.background}>
                {/* <section className='notice-maintaince'>
                    <h3 style={{margin:'0px'}}>Scheduled Maintenance Notice</h3>
                    <p>We are currently undergoing planned maintenance and migration. During this time, some ideas may not appear on the platform. We are working to restore full functionality as quickly as possible.</p>
                    <p style={{margin:"0px"}}><b>Thank you for your patience and understanding.</b></p>
                </section> */}
                <HeroSectionComponents
                    showIdeaChallengeModal={showIdeaChallengeModal}
                    setShowIdeaChallengeModal={setShowIdeaChallengeModal}
                    {...props}
                />
                <Container>
                    <LatestIdeaComponents AllIdeasPath={AllIdeasPath} {...props} />
                    <LatestChallengeComponents AllChallengesPath={AllChallengesPath}  {...props} />
                    {isHackathonEnable ? null : <GerericIdeaChallegeComponents
                        challenge_ideas={challenge_ideas}
                        // userIdeas={userIdeas}  
                        // challenges={challenges}
                        AllIdeasPath={AllIdeasPath}
                        AllChallengesPath={AllChallengesPath}
                        PROPOSECHALLENGEPath={PROPOSECHALLENGEPath}
                        NewCHALLENGEPath={NewCHALLENGEPath}
                        {...props}
                    />}
                </Container>
                {isHackathonEnable ? null : <div className={classes.contributors}>
                    {/* <Container> */}
                    <img src={contributorBg} className={classes.contributors_bg} alt='img' />
                    <div style={{ fontSize: '40px', marginTop: '48px' }}>Top Innovators</div>
                    <div className={classes.subtitle_text} style={{ marginBottom: '47px' }}>
                        Innovate would not be possible without our fantastic community, our most active innovators are:
                    </div>
                    <div className={classes.contributors_container}>
                        {footerInvestors.sort((a, b) => b.amountInvested - a.amountInvested).slice(0, 2)
                            .map(investor => <Contributor
                                key={investor.amountInvested}
                                contributor={investor}
                                type={contributorTypes.INVESTOR} />)}
                        {footerEntrepreneurs.sort((a, b) => b.ideas - a.ideas).slice(0, 2)
                            .map(ideator => <Contributor
                                key={ideator.amountInvested}
                                contributor={ideator}
                                type={contributorTypes.IDEATOR} />)}
                    </div>
                    <Link style={{ zIndex: 10 }} className={classes.standard_button} to={`${RANKINGPAGEPath}`}>View details</Link>
                    {/* </Container> */}
                </div>}

            </main>

            <ParentComponentTnc
                userEmail={userEmail}
                isTermAcceptedFirstTimeIsLoading={isTermAcceptedFirstTimeIsLoading}
                updateTermAndConditionAcceptenceFn={updateTermAndConditionAcceptenceFn}
                isTermAcceptedFirstTime={isTermAcceptedFirstTime}
            />

        
            <ShowPopupCountrySelectFirstTime 
                // dialogOpenCountry={checkisCommunityAssignedFirstTime}
                // setDialogOpenCountry={false}
                userEmail={userEmail}
                postAddCountryAcceptenceFn={postAddCountryAcceptenceFn}
                isCommunityAssigned={checkisCommunityAssignedFirstTime}
                getCountriesList={getBenchCountriesList}
                loginUser={loginUser}
                currentDomain={currentDomain}
            />     


            {/* <button style={{background:'red',padding:'8px',margin:'8px'}} onClick={CountryApiTest}>Click Country API</button>
                <button style={{background:'red',padding:'8px',margin:'8px'}} onClick={CountryINApiTest}>Click Country API With IN</button>
                <button style={{background:'red',padding:'8px',margin:'8px'}} onClick={ApiTest}>Click API Test</button> */}


        </>
    )
}

export default withStyles(styles)(NewExplore)
